import { CSSProperties } from "react";
import Lottie from "react-lottie";
import SymphonyLoadingLottieWhite from 'assets/images/lotties/SymphonyLoading_White.json';
import SymphonyLoadingLottiePurple from 'assets/images/lotties/SymphonyLoading.json';
import { clsx, styx } from "modules/Utils";
import { useNavbar } from "Hooks/useNavbar";
import { NAV_BAR_WIDTH_EXPANDED } from "modules/Const";
import { useLocation } from "react-router-dom";
import useOrganization from "Hooks/useOrganization";
import useBrand from "Hooks/useBrand";
import useScreen from "Hooks/useScreen";
import Colors from "modules/Colors";

interface LoaderProps {
    className?: string;
    style?: CSSProperties | undefined;
    title?: string | React.ReactNode;
    height?: number;
    width?: number;
    color?: 'white' | 'purple';
    size?: number;
    isCentered?: boolean;
    isBackground?: boolean;
    rendererSettings?: {
        preserveAspectRatio?: string | undefined;
        context?: any;
        scaleMode?: any;
        clearCanvas?: boolean | undefined;
        progressiveLoad?: boolean | undefined;
        hideOnTransparent?: boolean | undefined;
        className?: string | undefined;
    } | undefined
}

const Loader = ({
    className,
    style,
    title,
    size = 24,
    color = "purple",
    isCentered = false,
    isBackground = false,
    rendererSettings,
}: LoaderProps) => {
    const location = useLocation();
    const { mobileView } = useScreen();
    const { shouldHideNavbar } = useNavbar();
    const { currentBrand } = useBrand();
    const { organization } = useOrganization();

    const loaderSize = size;

    const getLoaderColor = () => {
        switch (color) {
            case 'purple':
                return SymphonyLoadingLottiePurple;
            case 'white':
                return SymphonyLoadingLottieWhite;
            default:
                return SymphonyLoadingLottieWhite;
        }
    }

    return (
        <div
            className={clsx('loaderElement', className)}
            style={styx(
                sty.loaderElement,
                isCentered && {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    ...(
                        !shouldHideNavbar(location.pathname, organization, currentBrand) && !mobileView &&
                        { paddingLeft: NAV_BAR_WIDTH_EXPANDED }
                    )
                },
                isBackground && {
                    backgroundColor: Colors.greyLight,
                    width: '100%',
                    height: 150,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: 16,
                },
                style
            )}
        >
            <Lottie
                height={loaderSize}
                width={loaderSize}
                options={{
                    rendererSettings,
                    loop: true,
                    autoplay: true,
                    animationData: getLoaderColor(),
                }}
                isClickToPauseDisabled
                ariaRole="none"
            />
            {title &&
                <div className="loaderTitle">
                    {title}
                </div>
            }
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    loaderElement: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
    },
}

export default Loader;